<app-get-gis-data
  [askForDevelopmentArea]="askForDevelopmentArea"
  [areaType]="areaType"
  [areaTypes]="areaTypes"
  [disable]="disable"
  [selectedGisData]="selectedGisData"
  [gisDataForm]="inputForm.controls['connectionObject']"
  [isNewDevelopmentArea]="isNewDevelopmentArea"
  [eventsFromParent]="eventsToGis"
  [listNewDevelopmentAreas]="listDevelopmentAreas"
  (gisData)="changeGisData($event)"
  (resetCompanyLocation)="setNullCompanyLocation($event)"></app-get-gis-data>

<!-- Netzbetreiber / Messstellenbetreiber< -->
<!--<section *ngIf="selectedCompanyLocation">
  <h5>Netzbetreiber / Messstellenbetreiber</h5>
  <strong>{{selectedCompanyLocation.tenant.displayName}}</strong><br/>
  {{selectedCompanyLocation.contactData.street}} {{selectedCompanyLocation.contactData.streetNo}}
  {{selectedCompanyLocation.contactData.zipCode}} {{selectedCompanyLocation.contactData.city}}
</section>
-->

<section *ngIf="noCompanyLocation">
  <h4>Netzbetreiber / Messstellenbetreiber</h4>
  <span class="alert alert-danger">Kein Betriebsbereich für dieses Anschlussobjekt gefunden.</span>
</section>

<section *ngIf="noAreaInThisCompanyLocation">
  <span class="alert alert-danger">
    Die Sparte {{ areaType | areaText }} ist an dieser Adresse nicht verfügbar.
  </span>
</section>

<form
  *ngIf="inputFormAdditionalInfo && selectedGisData?.houseNo && !noAreaInThisCompanyLocation"
  [formGroup]="inputFormAdditionalInfo">
  <h4 style="margin-top: 1.5rem">Angaben zum Objekt</h4>
  <form-row>
    <mat-checkbox formControlName="isNewBuilding">ist ein Neubau</mat-checkbox>
  </form-row>

  <form-row>
    <mat-form-field fxFlex="50" appearance="outline">
      <mat-label>Art des Gebäudes</mat-label>
      <mat-select formControlName="buildingType" (selectionChange)="changeObjectType()">
        <mat-option
          *ngFor="let ele of commissioningDataService.getCommissioningPowerObjectTypeType()"
          [value]="ele.value">
          {{ ele.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form-row>

  <form-row *ngIf="inputFormAdditionalInfo.controls['buildingType'].value == 'MultiHouse'">
    <mat-form-field fxFlex="50" appearance="outline">
      <mat-label>Anzahl der Wohnungen</mat-label>
      <input matInput type="number" min="0" formControlName="numberOfFlats" />
    </mat-form-field>
    <mat-form-field fxFlex="50" appearance="outline">
      <mat-label>Anzahl sonstiger Anschlussnutzer</mat-label>
      <input matInput type="number" min="0" formControlName="numberOfOtherUsers" />
    </mat-form-field>
  </form-row>

  <form-row *ngIf="inputFormAdditionalInfo.controls['buildingType'].value == 'NonResidential'">
    <mat-form-field fxFlex="50" appearance="outline" *ngIf="objectUsages$ | async as objectUsages">
      <mat-label>Nutzungsart des Objekts</mat-label>
      <mat-select formControlName="objectUsage" *ngIf="objectUsages?.length > 0">
        <mat-option *ngFor="let type of objectUsages" [value]="type.description">
          {{ type.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="50" appearance="outline" *ngIf="!(objectUsages$ | async)">
      <mat-label>Nutzungsart des Objekts</mat-label>
      <input matInput type="text" formControlName="objectUsage" />
    </mat-form-field>

    <mat-form-field fxFlex="50" appearance="outline">
      <mat-label>Anzahl der Anschlussnutzer</mat-label>
      <input matInput type="number" min="0" formControlName="numberOfUsers" />
    </mat-form-field>
  </form-row>
</form>
